import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';
import { withFocusManagement } from 'helpers/swiper/swiperFocusManagement';

export default () => {
    const swiperEl = document.querySelector('.showroom-image-swiper');
    if (swiperEl) {
        const swiperConfig = withFocusManagement({
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            spaceBetween: 16,
            slidesPerView: 1.5,
            breakpoints: {
                380: {
                    slidesPerView: 2.5
                },
                769: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 4
                }
            }
        });

        // new Swiper
        const showroomSwiper = new Swiper('.swiper', swiperConfig);

        // Add GTM Event on slideChange
        showroomSwiper.on('slideChange', function () {
            trackEvent('Showroom', 'Slider', 'Showroom images');
        });
    }
};
